import { BASE_URL, getAxiosConfig } from "../../../../components/interface/Config";
import { apiHandler } from "../../../../services/authService";


export interface ExaminationSection {
  id: number;
  attributes: any;
  master_type_slug: string;
  name: string;
  slug: string;
  is_active: number;
}

export interface PatientHealthData {
  id: string;
  values: {
    date: string; // Keep date as string
    others: string[]; // Specify 'others' as an array of strings
    [key: string]: boolean | string[] | string | []; 
  };
}


export interface FetchPatientHealthDataResponse {
  patient_healths?: PatientHealthData[];
 
}


export interface GeneralAnswer {
  id: number;
  name: string;
  slug: string;
  masterTypeSlug: string;
  attributes: {
    icon: string;
    group: string;
    multiple: string; 
    reference_slug: string;
  };
  isActive: number; 
}


// Fetch examination sections
export const fetchExaminationSections = async (patientId: string): Promise<ExaminationSection[]> => {
  const url        = `${BASE_URL}/resource/masters/all?slug=systemic-examination&order_by=id&dir=1&patient_id=${patientId}`;
  const response       = await apiHandler('', 'GET',{}, url);

  if (!response) {
      throw new Error("No response received from the server");
  }

  const data = response.data

  console.log('response', data);

  // const response = await fetch(
  //   `${BASE_URL}/resource/masters/all?slug=systemic-examination&order_by=id&dir=1&patient_id=${patientId}`,
  //   {
  //     method: 'GET',
  //     headers: getAxiosConfig().headers,
  //   }
  // );

  // if (!response.ok) {
  //   throw new Error('Failed to fetch data');
  // }

  // const data = await response.json();
  console.log('data.data.masters', data.data.masters);
  var result =  data.data.masters.filter((section: ExaminationSection) => section.is_active === 1);
  console.log('result', result);
  return result;
};

// Fetch general answers based on slug
export const fetchGeneralAnswers = async (
  patientId: string,
  slug: string
): Promise<GeneralAnswer[]> => {
  const url        = `${BASE_URL}/resource/masters/all?attr_slug=${slug}&order_by=id&dir=1&with_values=true&patient_id=${patientId}&slug=systemic_sub_types`;
  const response   = await apiHandler('', 'GET',{}, url);

  if (!response) {
      throw new Error("No response received from the server");
  }

  const data = response.data
  console.log('response', data);

  // const response = await fetch(
  //   `${BASE_URL}/resource/masters/all?attr_slug=${slug}&order_by=id&dir=1&with_values=true&patient_id=${patientId}&slug=systemic_sub_types`,
  //   {
  //     method: 'GET',
  //     headers: getAxiosConfig().headers,
  //   }
  // );

  // if (!response.ok) {
  //   throw new Error('Failed to fetch general answers');
  // }

  // const data = await response.json();

 
  return data.data.masters
    .filter((answer: any) => answer.is_active === 1) 
    .map((answer: any) => ({
      id: answer.id,
      name: answer.name,
      slug: answer.slug,
      masterTypeSlug: answer.master_type_slug,
      attributes: answer.attributes,
      isActive: answer.is_active,
    }));
};


// examinationService.ts
export const fetchPatientHealthData = async (userId: string, slug: string, from: string, to: string) => {
    const url        = `${BASE_URL}/resource/patientHealth/all?user_id=${userId}&slug=${slug}&from=${from}&to=${to}`;
    const response       = await apiHandler('', 'GET',{}, url);

    if (!response) {
        throw new Error("No response received from the server");
    }

    const data = response.data

    // const response = await fetch(
    //   `${BASE_URL}/resource/patientHealth/all?user_id=${userId}&slug=${slug}&from=${from}&to=${to}`, 
    //   {
    //     method: 'GET',
    //     headers: {
    //         ...getAxiosConfig().headers,
    //         'Content-Type': 'application/json',
    //       },
    //   }
    // );
    // if (!response.ok) {
    //   throw new Error('Failed to fetch patient health data');
    // }
    // const data = await response.json();
    return data;
  };
  
